import React from 'react'
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom'

// Essential Components - Currently Used
import Account from '../Components/Account/Account'
import Profile from '../Components/Profile/Profile'
import BookDetails from '../Components/BookDetails/StoryBook/bookDetails'
import BookReadingPage from '../pages/BookReadingPage/BookReadingPage'
import Dashboard from '../Components/Dashboard/Dashboard.jsx'
import AccountSection from '../pages/account-section/AccountSection'
import AddProfile from '../pages/add-profile/add-profile.jsx'
import SignupUser from '../pages/signup-user/SignupUser'
import LoginUser from '../pages/login-user/login-user'
import ForgotPasswordUser from '../pages/forgot-password-user/forgot-password-user'
import OtpUser from '../pages/otp-user/otp-user'
import ResetPasswordUser from '../pages/reset-password-user'
import Verfication from '../Components/Verification/Verfication'
import NotFound from '../pages/NotFound/NotFound.jsx'
import PasswordConfirmation from '../Components/PasswordConfirmation/PasswordConfirmation.jsx'
import { getAuthToken, isTokenExpired, clearSessionAndRedirect } from '../Helpers/authSession'

const Routing = () => {
  // Public routes for unauthenticated users
  const publicRoutes = [
    { path: '/', element: <LoginUser /> },
    { path: '/signin', element: <LoginUser /> },
    { path: '/signup', element: <SignupUser /> },
    { path: '/forgot-password', element: <ForgotPasswordUser /> },
    { path: '/otp', element: <OtpUser /> },
    { path: '/reset-password', element: <ResetPasswordUser /> },
    { path: '/verification', element: <Verfication /> },
  ]

  // Private routes for authenticated users
  const privateRoutes = [
    { path: '/', element: <AccountSection /> },
    { path: '/select-profile', element: <AccountSection /> },
    { path: '/add-profile', element: <AddProfile /> },
    { path: '/dashboard', element: <Dashboard /> },
    { path: '/book-detail', element: <BookReadingPage /> },
    { path: '/account', element: <Account /> },
    { path: '/profile', element: <Profile /> },
    { path: '/PasswordConfirmation', element: <PasswordConfirmation /> },
  ]

  // Redirect component for handling route redirects
  const ReDirect = () => {
    const navigate = useNavigate()
    React.useEffect(() => {
      navigate('/')
    }, [navigate])
    return null
  }

  const authToken = getAuthToken()
  const isUserAuthenticated = !!authToken && !isTokenExpired(authToken)
  const hasStoredSession = !!localStorage.getItem('data') || !!localStorage.getItem('profileId')

  if (authToken && !isUserAuthenticated) {
    clearSessionAndRedirect()
    return null
  }

  return (
    <BrowserRouter>
      <Routes>
        {(isUserAuthenticated ? privateRoutes : publicRoutes).map((route) => (
          <Route key={route.path} {...route} />
        ))}

        {/* Fallback route for 404 */}
        <Route
          path="*"
          element={
            isUserAuthenticated
              ? <NotFound />
              : <Navigate to={hasStoredSession ? '/signin?sessionExpired=true' : '/signin'} replace />
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default Routing
